import ApiService from "./api.service";
export default class GiftConfigurationService extends ApiService {
    static base_url = `${super.base_url}/gift_configurations`;

    static async reorder(orderedIds, axiosInstance) {
        const response = await axiosInstance.patch(`${this.base_url}/reorder`, {
            ordered_ids: orderedIds,
        });
        return response.data;
    }
}
